module.exports = __webpack_public_path__ + "static/img/function-box-img4.05c17d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/function-box-img4.png
// module id = 0eKm
// module chunks = 0